import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";

import { compactCents, formatCents, formatCompetenceShort } from "../../utils/directorFormat";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const PROJECT_COLORS = ["#7455FB", "#00AFC7", "#FD7A53", "#35516F", "#9B6B43"];

// Acumulado desde o primeiro mês: linha cheia no realizado, tracejada na projeção.
const ProjectCapitalChart = ({ portfolio, projects = [] }) => {
  const months = portfolio?.months || [];
  const labels = months.map((month) => formatCompetenceShort(month.competence));
  const firstProjected = months.findIndex((month) => !month.realized);
  const projected = (context) => (
    firstProjected >= 0 && context.p1DataIndex > firstProjected ? [6, 5] : undefined
  );
  const series = (curveMonths) => {
    const byCompetence = new Map((curveMonths || []).map((month) => [month.competence, month.cumulativeCents]));
    return months.map((month) => {
      const value = byCompetence.get(month.competence);
      return Number.isSafeInteger(value) ? value / 100 : null;
    });
  };
  const datasets = [
    ...(projects.length > 1 ? projects.map((project, index) => {
      const color = PROJECT_COLORS[index % PROJECT_COLORS.length];
      return {
        label: project.name,
        data: series(project.months),
        borderColor: color,
        backgroundColor: color,
        borderWidth: 2,
        pointRadius: 0,
        tension: 0.15,
        spanGaps: false,
        segment: { borderDash: projected },
      };
    }) : []),
    {
      label: projects.length > 1 ? "Portfólio" : (projects[0]?.name || "Portfólio"),
      data: series(months),
      borderColor: "#1C2030",
      backgroundColor: "#1C2030",
      borderWidth: 3,
      pointRadius: 0,
      tension: 0.15,
      segment: { borderDash: projected },
    },
    {
      label: "Zero",
      data: months.map(() => 0),
      borderColor: "#9AA3B5",
      borderDash: [2, 4],
      borderWidth: 1,
      pointRadius: 0,
    },
  ];
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { intersect: false, mode: "index" },
    plugins: {
      legend: { position: "bottom", labels: { usePointStyle: true, boxWidth: 8, filter: (item) => item.text !== "Zero" } },
      tooltip: {
        filter: (item) => item.dataset.label !== "Zero",
        callbacks: { label: (context) => `${context.dataset.label}: ${formatCents(Math.round(context.parsed.y * 100))}` },
      },
    },
    scales: {
      x: { grid: { display: false }, ticks: { maxTicksLimit: 12, autoSkip: true } },
      y: { ticks: { callback: (value) => compactCents(Math.round(Number(value) * 100)) } },
    },
  };

  return <div className="director-runway__canvas" aria-hidden="true">
    <Line data={{ labels, datasets }} options={options} />
  </div>;
};

export default ProjectCapitalChart;
